import { Box } from '@mui/material';
import Xarrow from 'react-xarrows';
import checkmark from '../../../../icons/checkmark.png';
import cross from '../../../../icons/cross.png';

interface ConnectionProps {
  start: string;
  end: string;
  isConnected: boolean;
}

const ConnectionArrow: React.FC<ConnectionProps> = ({ start, end, isConnected }) => {
  return (
    <Xarrow
      start={start}
      end={end}
      color={isConnected ? "var(--success)" : "var(--muted-foreground)"}
      strokeWidth={3}
      showHead={false}
      path="straight"
      dashness={!isConnected}
      labels={{
        middle: (
          <Box>
            <img src={isConnected ? checkmark : cross} alt={isConnected ? "Connected" : "Disconnected"} />
          </Box>
        ),
      }}
    />
  );
};

export default ConnectionArrow;
